import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';
import { IConnectToDonorStatus, IDonorConnect, IListItem } from '@nkr/models/index';
import { ConnectToDonorMilestone } from '@nkr/enums/index';
import { Badge, Button, Col, ControlLabel, DropdownButton, FormControl, FormGroup, Glyphicon, MenuItem, Panel, PanelGroup, Row } from 'react-bootstrap';
import MaskedInput from 'react-maskedinput';
import { donorConnectTabs, ICounselor, ICounts, milestones } from './models';
import Log from '../donor-connect/log';
import styled from 'styled-components';

const DropdownButtonWrapper = styled.div`
    & > .dropdown {
        width: 100%;
    }

    & > .dropdown > button {
        width: 100%;
    }

    & > .dropdown > .dropdown-menu {
        width: 100%;
    }

    & > .dropdown > ul > li > a > .row > .col-xs-5,
    & > .dropdown > ul > li > a > .row > .col-xs-7 {
        padding-left: 5px;
        padding-right: 5px;
    }
`;

interface IProps {
    list: IDonorConnect[],
    currentTab: JSX.Element | string,
    counts: ICounts,
    statusList: IConnectToDonorStatus[],
    userList: ICounselor[],
    actionList: IListItem[],
    onTabChange: (currentTab: string) => void,
    onStatusChange: (id: number, statusId: number) => void,
    onAssignedCounselorChange: (id: number, counselorId: number) => void,
    onNextFollowUpDateChange: (id: number, value: any) => void,
    onUpdateNextFollowupDate: (id: number) => void,
    onRemoveNextFollowUpDate: (id: number) => void,
    onSaveLogEntry: (id: number, dashRegistrationId: number, actionTaken: number, comments: string) => void,
    onDeleteLogEntry: (id: number, dashRegistrationId: number) => void,
    onGetIldaLogEntries: (id: number, view: boolean) => void
}

interface IState {
    registrationId: number,
    mobileActiveKey: any,
    search: string
}

class MobileView extends React.Component<IProps, IState> {
    readonly state: IState = {
        registrationId: 0,
        mobileActiveKey: null,
        search: ''
    }

    getCurrentTab = () => {
        let counts = this.props.counts;

        switch (this.props.currentTab) {
            case donorConnectTabs.UNASSIGNED: return <>UNASSIGNED ({counts.unassigned})</>;
            case donorConnectTabs.TODO: return <>TO-DO ({counts.todo})</>;
            case donorConnectTabs.MINE: return <>ASSIGNED TO ME ({counts.assignedToMe})</>;
            case donorConnectTabs.ALL: return <>ALL ({counts.all})</>;
        }

        return '';
    }


    handleSearchChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            search: e.currentTarget.value
        });
    }

    handlePanelItemSelect = async (mobileActiveKey: any) => {
        this.props.onGetIldaLogEntries(mobileActiveKey, false);

        this.setState({
            mobileActiveKey
        });
    }

    render = () => {
        const { list, counts, statusList, userList, actionList } = this.props;

        const currentTab = this.getCurrentTab();
        const search = this.state.search.toUpperCase();
        const filteredList = search.length >= 3 ? list.filter(x => x.firstName.toUpperCase().indexOf(search) >= 0 || x.lastName.toUpperCase().indexOf(search) >= 0) : list;
        const sortedList = _.sortBy(filteredList, item => item.lastName);

        return (
            <>
                <div>
                    <DropdownButtonWrapper style={{ marginBottom: 10 }}>
                        <DropdownButton
                            id='m-1'
                            title={currentTab}
                        >
                            <MenuItem href='/ilda/unassigned' eventKey='UNASSIGNED'>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div>UNASSIGNED</div>
                                    <div>{counts.unassigned}</div>
                                </div>
                            </MenuItem>
                            <MenuItem href='/ilda/to-do' eventKey='TODO'>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div>TO-DO</div>
                                    <div>{counts.todo}</div>
                                </div>
                            </MenuItem>
                            <MenuItem href='/ilda/assigned-to-me' eventKey='MINE'>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div>ASSIGNED TO ME</div>
                                    <div>{counts.assignedToMe}</div>
                                </div>
                            </MenuItem>
                            <MenuItem href='/ilda/all' eventKey='ALL'>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div>ALL</div>
                                    <div>{counts.all}</div>
                                </div>
                            </MenuItem>
                        </DropdownButton>
                    </DropdownButtonWrapper>

                    <FormGroup>
                        <ControlLabel>Search</ControlLabel>
                        <FormControl
                            placeholder='Enter 3 or more characters to search by the name...'
                            value={this.state.search}
                            onChange={this.handleSearchChange}
                        />
                    </FormGroup>

                    {sortedList.length == 0 && (
                        <div>No registrations found...</div>
                    )}

                    <PanelGroup accordion activeKey={this.state.mobileActiveKey} onSelect={this.handlePanelItemSelect}>
                        {sortedList.map(item => {
                            const disableNextFollowUpDateSaveButton = moment(item.connectToDonorNextFollowUpDate, 'MM/DD/YYYY', true).isValid() == false;
                          

                            return (
                                <Panel key={'dc-' + item.id} eventKey={item.id}>
                                    <Panel.Heading>
                                        <Panel.Title componentClass='h3' toggle>{item.firstName} {item.lastName}</Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body collapsible>
                                        <FormGroup>
                                            <ControlLabel>Email</ControlLabel>
                                            <div>{item.email}</div>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Phone Number(s)</ControlLabel>
                                            {item.phoneNumber != '' ?
                                                <>
                                                    <div>{item.phoneNumber}</div>
                                                 
                                                </>
                                                :
                                                <div>--</div>
                                            }
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Location</ControlLabel>
                                            <div>
                                                {item.city != '' && item.state != '' ?
                                                    <div>{item.city}, {item.state}</div>
                                                    :
                                                    <div>--</div>
                                                }
                                            </div>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Center</ControlLabel>
                                            <div>{item.centerAlias}</div>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Status</ControlLabel>
                                            <div>
                                                <FormControl
                                                    componentClass='select'
                                                    value={item.connectToDonorStatusId}
                                                    onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => this.props.onStatusChange(item.id, parseInt(e.currentTarget.value))}
                                                >
                                                    {statusList.map(item =>
                                                        <option key={'st-' + item.id} value={item.id}>{item.description}</option>
                                                    )}
                                                </FormControl>
                                            </div>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Assigned Counselor</ControlLabel>
                                            <div>
                                                <FormControl
                                                    componentClass='select'
                                                    value={item.connectToDonorAssignedUserId}
                                                    onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => this.props.onAssignedCounselorChange(item.id, parseInt(e.currentTarget.value))}
                                                >
                                                    <option value={0}>- Not Assigned -</option>
                                                    {userList.map(item =>
                                                        <option key={'au-' + item.id} value={item.id}>{item.firstName} {item.lastName} ({item.activeCaseCount}/{item.donorConnectCaseLoad})</option>
                                                    )}
                                                </FormControl>
                                            </div>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Next Follow-Up Date</ControlLabel>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <div style={{ marginRight: 5 }}>
                                                    <MaskedInput
                                                        mask='11/11/1111'
                                                        placeholder='mm/dd/yyyy'
                                                        className='form-control'
                                                        value={item.connectToDonorNextFollowUpDate}
                                                        onChange={(e: any) => this.props.onNextFollowUpDateChange(item.id, e.currentTarget.value)}
                                                    />
                                                </div>

                                                <div style={{ marginRight: 5 }}>
                                                    <Button bsStyle='primary' bsSize='xs' disabled={disableNextFollowUpDateSaveButton} title='Save specified date' onClick={() => this.props.onUpdateNextFollowupDate(item.id)}>
                                                        <Glyphicon glyph='ok' />
                                                    </Button>
                                                </div>

                                                <div>
                                                    <Button bsStyle='danger' bsSize='xs' disabled={disableNextFollowUpDateSaveButton} title='Remove specified date' onClick={() => this.props.onRemoveNextFollowUpDate(item.id)}>
                                                        <Glyphicon glyph='trash' />
                                                    </Button>
                                                </div>
                                            </div>
                                        </FormGroup>                                  

                                        <Log
                                            data={item}
                                            statusList={statusList}
                                            actionList={actionList}
                                            userList={userList}
                                            container={this}
                                            isMobile={true}
                                            onSaveLogEntry={this.props.onSaveLogEntry}
                                            onDeleteLogEntry={this.props.onDeleteLogEntry}
                                        />
                                    </Panel.Body>
                                </Panel>
                            );
                        })}
                    </PanelGroup>
                </div>
  
            </>
        );
    }
}

export default MobileView;